import BannerLang from './banner-lang';

const LoadBanner = {
    init() {
        LoadBanner.loadBannerAjax();
    },
    loadBannerAjax() {
        // eslint-disable-next-line no-undef
        const currentLang = jQuery('body').data('lang').toLowerCase();
        const showBanner = jQuery('body').data('show-banner-lang');

        if (showBanner) {
            $.ajax(
                {
                    type: 'POST',
                    url: scripts.ajax_url,
                    data: {
                        action: 'load_banner_by_lang', // Action hook defined in functions.php
                        currentLang,
                    },
                    success(response) {
                        $('body').prepend(response);
                        BannerLang.init();
                    },
                }
            );
        }
    },
};

export default LoadBanner;
